import Alpine from 'alpinejs';
import * as bootstrap from 'bootstrap';
import '@floating-ui/dom';
import '@popperjs/core';
import './time.js';
import './tooltips.js';
import './bootstrap';
import './hacks.js';
import './editors.js';
import './fontawesome/brands.js';
import './fontawesome/solid.js';
import './megapack.js';
import './newsModal.js';
import './apps/league2022/league2022.js'
import './apps/league2023/league2023.js';
import './apps/league2024/league2024.js';
import './rom-patcher.js';
import './hackForm.js';
import './cookies.js';
import './eventForm.js';

window.Alpine = Alpine;
window.bootstrap = bootstrap;

Alpine.start();

console.log('RASEAC', 46, 'ERENEGIV', 'SLLAF YTIVARG');